import { makeStyles } from '@material-ui/styles'

export default makeStyles((theme) => ({
  paperMenu: {
    boxShadow: `0 5px 10px 0 ${theme.palette.web.shadowGrey}`
  }
}))
